import React from 'react'
import { Nav, Tab } from 'react-bootstrap';

export const TabComponent = ({user, currentTab}) => {
    // console.log('currentTab', currentTab)
    return (
        <>
            <Tab.Container id='submenu-header' defaultActiveKey={currentTab.tabs[0].eventKey}>
                <Nav variant='pills' className='justify-content-center border-bottom border-1 spread-font '>
                    {currentTab.tabs.map((tab, index) => (
                        <Nav.Item key={index} bsPrefix='subheader-item'>
                            <Nav.Link
                                as='button'
                                bsPrefix='subheader-link'
                                eventKey={tab.eventKey}>
                                <p>{tab.title}</p>
                            </Nav.Link>
                        </Nav.Item>
                    ))}
                </Nav>
                <Tab.Content className='gx-0 px-0 mx-0'>
                    {currentTab.tabs.map((tab, index) => (
                        <Tab.Pane key={index} eventKey={tab.eventKey} mountOnEnter unmountOnExit>
                            <div
                                // className='text-center
                                //         align-self-center
                                //         justify-content-md-center
                                //         overflow-y-scroll'
                                style={{
                                    margin: "15px",
                                    maxHeight: 'calc(100vh - 200px',
                                }}
                            >
                                {tab.component}
                            </div>
                        </Tab.Pane>
                    ))}
                </Tab.Content>
            </Tab.Container>
        </>
    )
}
